module.exports = __webpack_public_path__ + "static/img/img-jjrInfo_banner.1aaf0de6.png";